import { render, staticRenderFns } from "./main-debug.vue?vue&type=template&id=d6f90fb8&scoped=true&"
import script from "./main-debug.vue?vue&type=script&lang=js&"
export * from "./main-debug.vue?vue&type=script&lang=js&"
import style0 from "./main-debug.vue?vue&type=style&index=0&id=d6f90fb8&lang=scss&scoped=true&"
import style1 from "./main-debug.vue?vue&type=style&index=1&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d6f90fb8",
  null
  
)

export default component.exports